export default "__VITE_ASSET__D1YVxQuk__"